import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderBy } from '../enums/order-by.enum';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'ticketsOrderBy',
})
export class TicketsOrderByPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(orderBy: OrderBy): string {
        switch (orderBy) {
            case OrderBy.lastThreadActivityDesc:
                return this.translateService.instant('Newest by thread activity');
            case OrderBy.lastThreadActivityAsc:
                return this.translateService.instant('Oldest by thread activity');
            case OrderBy.lastAnyActivityDesc:
                return this.translateService.instant('Newest by any activity');
            case OrderBy.lastAnyActivityAsc:
                return this.translateService.instant('Oldest by any activity');
            case OrderBy.creationTimeDesc:
                return this.translateService.instant('Newest by creation');
            case OrderBy.creationTimeAsc:
                return this.translateService.instant('Oldest by creation');
            case OrderBy.importanceDesc:
                return this.translateService.instant('High importance');
            case OrderBy.importanceAsc:
                return this.translateService.instant('Low importance');
            case OrderBy.expirationTimeAsc:
                return this.translateService.instant('Expiring soon');
            default:
                return this.translateService.instant('Unknown type');
        }
    }
}
